import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Avatars from './avatars';
import Validation from './validation';

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nickname: '',
      avatarFileName: '',
      message: {
        nickname: '',
        avatarFileName: '',
      },
    };
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({ nickname: nextProps.playerSettings.nickname });
    this.setState({ avatarFileName: nextProps.playerSettings.avatarFileName });
  };

  onSubmit = (event) => {
    event.preventDefault();
    const valid = this.validate();
    if (valid) {
      const values = {};
      Object.assign(values, this.state);
      delete values.message;
      this.props.handleRegister(values);
    }
  };

  onCancel = (event) => {
    event.preventDefault();
    this.props.handleCancel();
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
    this.setState({
      message: {
        ...this.state.message,
        [name]: Validation.formValidate(name, value),
      },
    });
  };

  validate = () => {
    const nickname = Validation.formValidate('nickname', this.state.nickname);
    const avatarFileName = Validation.formValidate('avatarFileName', this.state.avatarFileName);

    this.setState({
      message: { nickname, avatarFileName },
    });
    return nickname === '' && avatarFileName === '';
  };

  renderCancel = () => {
    const display = this.props.playerSettings.nickname && this.props.playerSettings.avatarFileName;
    // const isLoggedIn = this.state.isLoggedIn;
    return display ? (
      <Button type="button" size="large" variant="outlined" className="profile-button-block" onClick={this.onCancel} >
        <FormattedMessage id="profile.cancel_button" />
      </Button>
    ) : '';
  }

  render() {
    const { message } = this.state;
    return (
      <form
        id="profile-form"
        onSubmit={(e) => { this.onSubmit(e); }}
        onCancel={(e) => { this.onCancel(e); }}
      >
        <div className="profile-input-element">
          <TextField
            id="nickname"
            name="nickname"
            label={<FormattedMessage id="profile.nickname_label" />}
            value={this.state.nickname}
            onChange={this.handleChange}
            className="profile-input-text-field"
            margin="normal"
            variant="outlined"
          />
        </div>
        {message.nickname && (
          <p className="profile-input-message">{message.nickname}</p>
        )}
        <Avatars
          selectedAvatar={this.state.avatarFileName}
          handleChangeAvatar={this.handleChange}
        />
        {message.avatarFileName && (
          <p className="profile-input-message">{message.avatarFileName}</p>
        )}
        <div className="profile-input-element">
          <Button type="submit" size="large" variant="contained" color="primary" className="profile-button-block" >
            <FormattedMessage id="profile.register_button" />
          </Button>
          {this.renderCancel()}
        </div>
      </form>
    );
  }
}

Form.propTypes = {
  handleRegister: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  playerSettings: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Form;
